import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';
export var updateEditIncomingPort = mutatorAction('updateEditIncomingPort', function (port) {
    var store = connectedAccountsStore();
    store.editAccountState.incomingPort = port;
});
//# sourceMappingURL=updateEditIncomingPort.js.map